<div class="flex min-h-0 flex-1 flex-col">
    <div class="table-actions-wrapper flex min-h-0 flex-1 flex-col" [class.disabled]="!isTableActive" *ngIf="!isLoading; else tableShimmer">
        <div fxLayoutAlign="space-between center" class="mb-12 shrink-0">
            <h3 class="mb-0 mt-0">{{ 'ENGAGE.EXPERIENCE.TITLE.SINGULAR' | translate }}</h3>

            <app-search-outline [searchInput]="searchInput"></app-search-outline>
        </div>

        <div #experienceTableScrollHost class="w-100-p table-wrapper white" *ngIf="dataSource">
            <span id="ruler" class="ruler"></span>

            <mat-table #table [dataSource]="dataSource.data | search: searchInput.value" matSort>
                <!-- Name Column -->
                <ng-container matColumnDef="name">
                    <mat-header-cell class="pl-24 pr-8" *matHeaderCellDef></mat-header-cell>

                    <mat-cell #nameCell *matCellDef="let experience" class="pl-24 pr-8" fxLayout="column" fxLayoutAlign="center start">
                        <span class="text-truncate font-semibold w-100-p">{{ experience.name }}</span>
                    </mat-cell>
                </ng-container>

                <!-- Buttons Column -->
                <ng-container matColumnDef="buttons">
                    <mat-header-cell *matHeaderCellDef></mat-header-cell>

                    <mat-cell *matCellDef="let experience">
                        <div fxFlex="row" fxLayoutAlign="end center">
                            <app-flat-button [label]="'GENERAL.BUTTON.ADD'" (onClick)="addToList(experience); onSelection()" *ngIf="!experience.selected"></app-flat-button>

                            <app-white-button
                                [label]="'GENERAL.BUTTON.UNSELECT'"
                                (onClick)="removeFromList(experience); onSelection()"
                                *ngIf="experience.selected"
                            ></app-white-button>
                        </div>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

                <mat-row
                    *matRowDef="let experience; columns: displayedColumns"
                    [attr.data-experience-selected-row]="experience.selected ? true : null"
                    matRipple
                >
                </mat-row>
            </mat-table>
        </div>
    </div>

    <mat-checkbox class="mt-16 shrink-0" [(ngModel)]="isUnassignedSelected" (change)="onSelection()" *ngIf="!isLoading">
        {{ 'GENERAL.LABEL.UNASSIGNED_EXPERIENCE' | translate }}
    </mat-checkbox>
</div>

<ng-template #tableShimmer>
    <div class="table-actions-wrapper flex min-h-0 flex-1 flex-col">
        <div fxLayoutAlign="space-between center" class="mb-12 shrink-0">
            <h3 class="mb-0 mt-0">{{ 'ENGAGE.EXPERIENCE.TITLE.SINGULAR' | translate }}</h3>
        </div>
        <div class="table-wrapper filter-table-shimmer">
            <div class="shimmer-container py-16 px-16">
                <div class="shimmer" *ngFor="let item of [1, 2, 3, 4, 5]">
                    <div fxLayout="row" fxLayoutAlign="flex-start center" class="mb-16">
                        <div class="shimmer-title w-100-p animate mb-0"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
